export interface IByggKundeResult {
    kundeNummer: string;
    byggNummer: string;
}

export class ByggKundeResult implements IByggKundeResult {
    public kundeNummer: string;
    public byggNummer: string;

    public constructor(params: IByggKundeResult) {
        Object.assign(this, params);
    }
}
